<template>
  <div id="app">
    <div class="opencc-main">
      <h1>英文大小写转换工具</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12 m-b-10">
          <div class="text-center">
            <button class="btn btn-info btn-w-xl m-5 btnClipboard" type="button" data-clipboard-action="copy" data-clipboard-target="#textClipboard"><i class="mdi mdi-content-copy"></i> 复制结果</button>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-6 m-b-10">
          <textarea class="form-control border-info" placeholder="输入要转换的字.." auto-height rows="6" v-model="inputText" ref="intextarea" :style="{'height': height}"></textarea>
          <div class="help-block">在左边输入要转换的字，右边自动输出转换结果..</div>
        </div>
        <div class="col-md-6 m-b-10">
          <textarea class="form-control"  placeholder="转换输出.." auto-height readonly rows="6" id="textClipboard" v-model="outputText" :style="{'height': height}"></textarea>


          <div class="m-t-10 clearfix">
            <label class="lyear-switch switch-solid switch-success"  style="float: left;">
              <input type="checkbox" v-model="stripTags">
              <span></span>
            </label>
            <div style="margin-left:10px; float: left;">从中删除HTML标记</div>
        
          </div>
          <div class="m-t-10">
              转换：<label class="lyear-checkbox checkbox-inline checkbox-primary">
                <input type="radio" name="convert_type" value="upper" v-model="convertType"><span>全大写</span>
              </label>
              <label class="lyear-checkbox checkbox-inline checkbox-primary">
                <input type="radio" name="convert_type" value="lower" v-model="convertType"><span>全小写</span>
              </label>
              <label class="lyear-checkbox checkbox-inline checkbox-primary">
                <input type="radio" name="convert_type" value="title" v-model="convertType"><span>首字母大写</span>
              </label>
              <label class="lyear-checkbox checkbox-inline checkbox-primary">
                <input type="radio" name="convert_type" value="camel" v-model="convertType"><span>小驼峰法</span>
              </label>
          </div>
          <div class="m-t-10">
              分隔：
              <label class="lyear-checkbox checkbox-inline checkbox-primary">
                <input type="radio" name="convert_type" value="kebab" v-model="convertType"><span>减号“-”分隔</span>
              </label>
              <label class="lyear-checkbox checkbox-inline checkbox-primary">
                <input type="radio" name="convert_type" value="snake" v-model="convertType"><span>下划线“_”分隔</span>
              </label>
          </div>
         
          <div class="m-t-10" v-if="count>0">
             <hr/>
            <p>字符数：{{ count }} 个</p>
            <p>单词数：{{ countWords }} 个</p>
          </div>
        </div>
      </div>


      <div class="alert alert-info alert-kepu">
        <p><strong>英文大小写转换示例：</strong></p>
        <p>全大写：abc => ABC</p>
        <p>全小写：aBc => abc</p>
        <p>首字母大写：abc => Abc</p>
        <p>小驼峰法：abc to camel => abcToCamel</p>
        <p>减号“-”分隔：abc to kebab => abc-to-kebab</p>
        <p>下划线“_”分隔：abc to snake => abc_to_snake</p>
        <hr/>
        <p><i class="mdi mdi-24px mdi-spin mdi-star"></i> <strong>本工具优点</strong></p>
        <p>与传统大小写转换工具相比，页面分左右设计，输入输出更直观，而且在左边输入时右边即时转出，省去点击鼠标，可以节省50%操作时间，建议收藏</p>
      </div>
    
    </div>
  </div>
</template>

<script>


// import Vue from 'vue';
import Clipboard from 'clipboard';
import calcTextareaHeight from './assets/calcTextareaHeight.js';
import voca from 'voca';
// var a= voca.kebabCase('goodbye blue sky'); // => 'goodbye-blue-sky'
// console.log(a);

export default {
  name: 'App',
  components: {
    Clipboard
  },
  data:function() {
   
		return {
      height: '150px',
      convertType:'upper',
      stripTags:false,
      count:0,
      countWords:0,
      inputText:'',
      outputText:''
		};
	},
  watch: {
    inputText() {
      this.getHeight();
      this.convert();
    },
    convertType() {
      this.convert();
    },
    stripTags() {
      this.convert();
    }
  },
	mounted:function(){
    //bind domain
    // if(!location.hostname.match(/ima.co/) && !location.hostname.match(/zqrcode.c/) && !location.hostname.match(/zqrhk.c/)){
    //   location.href = 'https://www.2weima.com/?diysafe='+ encodeURIComponent(location.href);
    //   $('body').html('');
    //   return ;
    // }
    // Function("‌‍‍‌‍‌‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‌‍‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‌‌‍‌‍‍‍‍‌‍‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‌‌‌‌‍‍‍‌‌‍‍‌‌‍‍‍‌‍‌‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‌‍‌‍‍‍‌‌‌‍‍‌‌‍‌‌‍‍‍‌‍‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‍‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‌‌‍‍‌‌‍‍‌‌‍‌‍‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‌‍‌‌‍‌‌‍‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‍‍‍‌‌‌‌‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‍‌‍‌‌‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‌‍‌‌‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‍‍‌‌‌‍‌‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‍‍‌‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‌‍‍‌‍‌‍‍‌‍‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‍‍‌‌‍‍‍‍‍‌‍".replace(/.{8}/g,function(u){return String.fromCharCode(parseInt(u.replace(/\u200c/g,0).replace(/\u200d/g,1),2))}))();
    this.$nextTick(() => {
      this.init();
    });


	},
	methods: {
    getHeight() {
    
      var height = calcTextareaHeight(this.$refs.intextarea, 6, null).height;
      
      this.height  = height < 150 ? 150 : height;
    },
		init:function(){
    
      var clipboard = new Clipboard('.btnClipboard');

			clipboard.on('success', function(e) {
        $common.showNotify('复制成功','success');
				e.clearSelection();
			});
			clipboard.on('error', function(e) {
        $common.showNotify('复制失败，浏览器不支持，请手工复制','warning');
			});

		},
    convert:function(){

      var inputText = voca.trim(this.inputText);

      if(this.stripTags){
        inputText = voca.stripTags(inputText);
      }
      this.count = voca.count(inputText);
      this.countWords = voca.countWords(inputText);
    
      switch (this.convertType) {
        case 'upper':
          this.outputText = voca.upperCase(inputText);
          break;
        case 'lower':
          this.outputText = voca.lowerCase(inputText);
          break;
        case 'title':
          inputText = voca.lowerCase(inputText);
          this.outputText = voca.titleCase(inputText);
          break;
        case 'camel':
          this.outputText = voca.camelCase(inputText);
          break;
        case 'kebab':
          this.outputText = voca.replaceAll(inputText,' ','-');
          break;
        case 'snake':
          this.outputText =voca.replaceAll(inputText,' ','_');
          break;
          
      
        default:
          break;
      }
      




    }
    
	}
}
</script>


<style scoped>
.opencc-main h1{
 font-size:22px;
 margin-bottom: 20px;
}
.alert-kepu{
  margin-top:50px;
}
.border-success{
  border:1px solid #15c377;
}
.border-info{
  border:1px solid #48b0f7;
}
</style>
